module.exports = __webpack_public_path__ + "static/media/NEAR.b9d463c5.svg";